/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import classNames from 'classnames';
import { CashBack } from '@lt/components';
import Wishlist from 'src/components/Wishlist';
import type { CurrencyType } from 'src/utils/stringUtils';
import HotelRatingSquare from 'src/components/HotelRatingSquare';
import HotelCardGallery from '../HotelCardGallery';
import type { HotelImage } from '../../types';
import AlreadySeenLabel from './components/AlreadySeenLabel';
import HotelCardStars from '../HotelCardStars';
import HotelCardTitle from '../HotelCardTitle';
import HotelCardLocation from '../HotelCardLocation';

import styles from './hotelCardGalleryOverlay.module.css';

type HotelCardGalleryOverlayProps = {
  images: HotelImage[];
  price: number;
  isMobile: boolean;
  hotelPageVisited: boolean;
  bonusCount: number;
  cashbackIdentifier?: string;
  customCashbackIconURL?: string;
  customCashbackText?: string;
  customCashbackTooltipText?: string;
  currencyCode: CurrencyType;
  stars: number;
  hotelName: string;
  hotelLocation: string;
  rating: number;
  reviewsCount?: number;
  id: number;
  isMapCard?: boolean;
  hotelPageHref: string;
  openInCurrentTab: boolean;
};

const HotelCardGalleryOverlay: React.FC<HotelCardGalleryOverlayProps> = (
  props,
) => {
  const {
    images,
    price,
    isMobile,
    hotelPageVisited,
    bonusCount,
    cashbackIdentifier,
    customCashbackIconURL,
    customCashbackText,
    customCashbackTooltipText,
    currencyCode,
    stars,
    hotelName,
    hotelLocation,
    rating,
    reviewsCount,
    isMapCard = false,
    hotelPageHref,
    openInCurrentTab,
    id,
  } = props;

  return (
    <div
      className={classNames(styles.overlay, {
        [styles.overlayMobile]: isMobile,
        [styles.overlayMapCardMobile]: isMobile && isMapCard,
      })}
    >
      {isMobile ? (
        <a
          className={styles.linkToHotel}
          href={hotelPageHref}
          target={openInCurrentTab ? '_self' : '_blank'}
        >
          <HotelCardGallery
            images={images}
            isMobile={isMobile}
            isMapCard={isMapCard}
          />
        </a>
      ) : (
        <HotelCardGallery
          images={images}
          isMobile={isMobile}
          isMapCard={isMapCard}
        />
      )}

      <div className={styles.labels}>
        {bonusCount ? (
          <CashBack
            className={styles.styledCashBack}
            count={`+${bonusCount}`}
            cashbackText
            isMobile={isMobile}
            isColumnLayout={!isMobile}
            type={cashbackIdentifier}
            customCashbackIconURL={customCashbackIconURL}
            customCashbackText={customCashbackText}
            customCashbackTooltipText={customCashbackTooltipText}
            currencyCode={currencyCode}
          />
        ) : null}
        {hotelPageVisited && <AlreadySeenLabel />}
      </div>

      <div className={styles.topRightOverlayPart}>
        {isMobile ? (
          <Wishlist
            price={price}
            className={styles.styledWishListButton}
            type="hotel"
            wishlistIdentifier={id}
            isWhiteHeart={isMobile}
            isHotelCardFromMap={isMapCard}
          />
        ) : (
          <HotelRatingSquare value={rating} reviewsCount={reviewsCount} />
        )}
      </div>

      {isMobile && (
        <div className={styles.bottomOverlayPart}>
          <div className={styles.titleWidth}>
            <HotelCardStars value={stars} />
            <HotelCardTitle
              hotelPageHref={hotelPageHref}
              isMobile={isMobile}
              openInCurrentTab={openInCurrentTab}
            >
              {hotelName}
            </HotelCardTitle>
            <HotelCardLocation isMobile={isMobile}>
              {hotelLocation}
            </HotelCardLocation>
          </div>
          <HotelRatingSquare value={rating} reviewsCount={reviewsCount} />
        </div>
      )}
    </div>
  );
};

export default HotelCardGalleryOverlay;
